module.exports = __webpack_public_path__ + "img/cast-icon-alt.b249bb63.svg";